/**
 * @generated SignedSource<<3760c55aa5d26f37fb92d37861f8dba2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterCategoryItemSlideshowNewsletterCategory$data = {
  readonly entityId: string;
  readonly name: string;
  readonly newsletters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"helpersNewsletterSlideshowItemGetSizeNewsletter" | "mynewsNewsletterItemNewsletter" | "newsletterItemNewsletter" | "plusNewsletterItemNewsletter">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "newsletterCategoryItemSlideshowNewsletterCategory";
};
export type newsletterCategoryItemSlideshowNewsletterCategory$key = {
  readonly " $data"?: newsletterCategoryItemSlideshowNewsletterCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterCategoryItemSlideshowNewsletterCategory">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterCategoryItemSlideshowNewsletterCategory",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "WEIGHT"
          }
        }
      ],
      "concreteType": "NewsletterConnection",
      "kind": "LinkedField",
      "name": "newsletters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NewsletterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Newsletter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersNewsletterSlideshowItemGetSizeNewsletter",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NewsletterCategory",
                      "kind": "LinkedField",
                      "name": "newsletterCategories",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormattedValue",
                      "kind": "LinkedField",
                      "name": "shortDescription",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "text",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "mynewsNewsletterItemNewsletter"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "newsletterItemNewsletter"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "plusNewsletterItemNewsletter"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "newsletters(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
    }
  ],
  "type": "NewsletterCategory",
  "abstractKey": null
};
})();

(node as any).hash = "2154e457a4b9d65c086c1ed0ac641e77";

export default node;
